import ReactSelect from "react-select";
import SelectCustomStyles from "../../utils/styles/reactSelect";

function AppSelect({ value, options = [], onChange, ...rest }) {
  const resolved =
    value != null && typeof value !== "object"
      ? (options.find((o) => o.value === value) ?? null)
      : value ?? null;

  const handleChange = (selected) => {
    if (!onChange) return;
    onChange(selected?.value ?? null, selected);
  };

  return (
    <ReactSelect
      value={resolved}
      options={options}
      onChange={handleChange}
      styles={SelectCustomStyles}
      {...rest}
    />
  );
}

export default AppSelect;
